<template>
  <div v-if="selectableModels?.length" class="product-model-selector rounded-xl shadow-md p-1 mb-2">
    <div class="w-full flex justify-between items-center mb-2">
      <div class="text-md font-normal" qaid="model-selector-label">{{ $t('product.family.detail.chooseModel') }}</div>
      <pdl-link
        standalone
        xsmall
        qaid="compare-models-link"
        href="#product-family-models-carousel-component"
        @click.prevent="scrollToModelCarousel"
      >
        <div>
          <span class="underline">{{ $t('product.fdp.compareModels') }}</span>
          <pdl-icon class="rotate-90" name="arrow_forward" />
        </div>
      </pdl-link>
    </div>
    <model-selector-card
      v-for="(model, index) in selectableModels"
      :key="`${model.code}`"
      v-model="modelId"
      :model="model"
      :qaid="`model-selector-card-${index}`"
    />
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import ModelSelectorCard from '@/components/containers/buy-zone/ModelSelectorCard.vue';
import {loadModelPricing} from '@/components/containers/pdp/utils/product-pricing.js';
import {scrollToElement} from '@/utils/scroll-to.js';
import {PdlLink} from '@pedal/pdl-link';
import {PdlIcon} from '@pedal/pdl-icon';

export default {
  components: {
    ModelSelectorCard,
    PdlLink,
    PdlIcon,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    subfamilyModels: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('familyDetails', ['models', 'selectedModelId']),
    ...mapGetters('productDetails', ['getConsumerPriceForVariant']),

    modelId: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (value === this.selectedModelId) return;
        this.$emit('update:modelValue', value);
      },
    },

    selectableModels() {
      if (!this.subfamilyModels?.length) return this.models;

      const models = this.models.filter((model) => this.subfamilyModels.includes(model.code));
      models.forEach((model) => {
        loadModelPricing(model);
      });
      return models;
    },

    selectedPrice() {
      return this.getConsumerPriceForVariant(this.modelId).displayPriceValue.value;
    },
  },
  mounted() {
    const found = this.selectableModels.some((model) => model.code === this.modelId);
    if (!found && this.selectableModels.length) {
      this.$emit('update:modelValue', this.selectableModels[0].code);
    }
  },
  methods: {
    scrollToModelCarousel() {
      scrollToElement(document.querySelector('#product-family-models-carousel-component'));
    },
  },
};
</script>

<style lang="scss" scoped>
.product-model-selector {
  :deep(.model-selector-card:last-child) {
    .pdl-card {
      margin-bottom: 0;
    }
  }
}
</style>
